if (typeof Graal === 'undefined') {return;}
__webpack_require__.l = function(url, done, key, chunkId) {
	var filePath = url;
	var publicPath = __webpack_require__.p
	if (publicPath && filePath.startsWith(publicPath)) {
		filePath = filePath.replace(__webpack_require__.p, './');
	}
	load(filePath);
	done();
}
